"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FromUrlInput;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

function FromUrlInput(_ref) {
  var error = _ref.error,
      value = _ref.value,
      onKeyUp = _ref.onKeyUp,
      onChange = _ref.onChange,
      onPreview = _ref.onPreview,
      disabled = _ref.disabled;
  return _react.default.createElement(_UIMedia.default, null, _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement(_UITextInput.default, {
    value: value,
    placeholder: _I18n.default.text('FileManagerLib.fromUrlPlaceholder'),
    error: !!error,
    onKeyUp: onKeyUp,
    onChange: onChange
  })), _react.default.createElement(_UIMediaRight.default, null, _react.default.createElement(_UIButton.default, {
    onClick: onPreview,
    use: "tertiary-light",
    disabled: disabled
  }, _I18n.default.text('FileManagerLib.actions.preview'))));
}

FromUrlInput.propTypes = {
  error: _propTypes.default.bool,
  disabled: _propTypes.default.bool.isRequired,
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onKeyUp: _propTypes.default.func.isRequired,
  onPreview: _propTypes.default.func.isRequired
};
FromUrlInput.defaultProps = {
  disabled: false
};
module.exports = exports.default;